import React from 'react'
import { Input } from '@node-space/ui-components'
import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import type { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'

type BankNameFieldProps = {
  register: UseFormRegister<ContactFiatInstrumentFormData>
  errors: FieldErrors<ContactFiatInstrumentFormData>
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const BankNameField = ({ register, errors, onChange }: BankNameFieldProps) => {
  const { t } = useTranslation()

  return (
    <Input
      {...register('bankName')}
      name="bankName"
      testId="bankName"
      label={t('beneficiarysBankName')}
      placeholder={t('enterBankName')}
      errorText={errors?.bankName?.message}
      error={!!errors?.bankName?.message}
      onChange={onChange}
    />
  )
}

